import {isLoggedIn} from '../../utils/auth'

export default (store) => {
  return ({
    path: 'b2b-offers-report',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      const Offer = require('./containers').default
      cb(null, Offer)
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/B2BOffersReport/index.js